module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNyIgaGVpZ2h0PSIxNyIgdmlld0JveD0iMCAwIDE3IDE3Ij4KICA8cGF0aCBmaWxsPSIjOTc5Nzk3IiBkPSJNMTAuMjgyIDguOWwzLjU2NyAzLjU2N2EuOTc3Ljk3NyAwIDEgMS0xLjM4MiAxLjM4MmwtMy41NjgtMy41NjctMy41NjcgMy41NjdhLjk3Ny45NzcgMCAxIDEtMS4zODItMS4zODJsMy41NjctMy41NjhMMy45NSA1LjMzMkEuOTc3Ljk3NyAwIDAgMSA1LjMzMiAzLjk1bDMuNTY3IDMuNTY3IDMuNTY4LTMuNTY3YS45NzcuOTc3IDAgMCAxIDEuMzgyIDEuMzgybC0zLjU2NyAzLjU2N3oiLz4KPC9zdmc+Cg=="


//////////////////
// WEBPACK FOOTER
// ./src/images/icon-close.svg
// module id = 152
// module chunks = 0